import { StandardEvents } from '@shopify/events';
import { SlideshowSelectEvent } from '@theme/events';

const states = new WeakMap();
function stateOf(root) {
  if (!states.has(root)) {
    try { states.set(root, JSON.parse(root.querySelector('[data-iv-share-config]').textContent)); }
    catch { return null; }
  }
  return states.get(root);
}
function details(root) {
  const state = stateOf(root);
  if (!state) return null;
  const url = new URL(state.url, window.location.origin);
  url.search = ''; url.hash = '';
  const current = new URL(window.location.href);
  const variant = state.variant || current.searchParams.get('variant');
  if (variant) url.searchParams.set('variant', String(variant));
  const image = state.image ? new URL(state.image, window.location.origin).href : '';
  return { title: state.title, url: url.href, image };
}
function update(root) {
  const data = details(root);
  if (!data) return;
  root.querySelectorAll('[data-iv-share-channel]').forEach(link => {
    const channel = link.dataset.ivShareChannel;
    if (channel === 'pinterest') {
      const url = new URL('https://www.pinterest.com/pin/create/button/');
      url.search = new URLSearchParams({ url: data.url, media: data.image, description: data.title });
      link.href = url.href;
    } else if (channel === 'facebook') link.href = `https://www.facebook.com/sharer/sharer.php?${new URLSearchParams({ u: data.url })}`;
    else if (channel === 'email') link.href = `mailto:?${new URLSearchParams({ subject: data.title, body: data.url })}`;
  });
  root.querySelectorAll('[data-iv-share-copy-field]').forEach(input => { input.value = data.url; });
}
function announce(root, text) { root.querySelectorAll('[data-iv-share-status]').forEach(node => { node.textContent = text; }); }
function openDialog(root) { update(root); const dialog = root.querySelector('[data-iv-share-dialog]'); if (!dialog.open) dialog.showModal(); }
function initialize() { document.querySelectorAll('[data-iv-product-share]').forEach(update); }

document.addEventListener('click', async event => {
  const button = event.target.closest?.('[data-iv-share-native], [data-iv-share-copy], [data-iv-share-close], [data-iv-share-channel]');
  const root = button?.closest('[data-iv-product-share]');
  if (!root) return;
  update(root);
  if (button.hasAttribute('data-iv-share-channel')) return;
  if (button.hasAttribute('data-iv-share-close')) { root.querySelector('[data-iv-share-dialog]').close(); return; }
  const data = details(root);
  if (!data) return;
  if (button.hasAttribute('data-iv-share-native')) {
    if (typeof navigator.share === 'function') {
      try { await navigator.share({ title: data.title, url: data.url }); }
      catch (failure) { if (failure.name !== 'AbortError') openDialog(root); }
    } else openDialog(root);
  } else {
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(data.url);
      announce(root, 'Link copied');
    } catch {
      const dialog = root.querySelector('[data-iv-share-dialog]');
      const container = dialog.open ? dialog : root;
      const manual = container.querySelector('[data-iv-share-manual]');
      manual.hidden = false;
      const field = manual.querySelector('input'); field.value = data.url; field.focus(); field.select();
      announce(root, 'Select and copy the link above.');
    }
  }
});
document.addEventListener(StandardEvents.productSelect, event => {
  if (!event.promise || !(event.target instanceof Element)) return;
  const section = event.target.closest('.shopify-section');
  if (!section) return;
  event.promise.then(({ detail }) => {
    const resource = detail?.resource;
    if (!resource) return;
    section.querySelectorAll('[data-iv-product-share]').forEach(root => {
      if (String(detail.productId) !== root.dataset.productId) return;
      const state = stateOf(root);
      if (!state) return;
      state.variant = resource.id;
      const image = resource.featured_media?.preview_image?.src || resource.featured_image?.src || resource.featured_image?.url;
      if (image) state.image = image;
      update(root);
    });
  }).catch(() => {});
});
document.addEventListener('click', event => {
  if (!event.target.matches?.('[data-iv-share-dialog]')) return;
  const dialog = event.target, rect = dialog.getBoundingClientRect();
  if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
});
document.addEventListener(SlideshowSelectEvent.eventName, event => {
  if (!(event.target instanceof Element) || !event.target.closest('media-gallery')) return;
  const image = event.detail?.slide?.querySelector('img');
  if (!image) return;
  event.target.closest('.shopify-section')?.querySelectorAll('[data-iv-product-share]').forEach(root => {
    const state = stateOf(root);
    if (state) { state.image = image.currentSrc || image.src; update(root); }
  });
});
let queued = false;
new MutationObserver(records => {
  if (queued || !records.some(record => [...record.addedNodes].some(node => node instanceof Element && (node.matches('[data-iv-product-share]') || node.querySelector('[data-iv-product-share]'))))) return;
  queued = true; queueMicrotask(() => { queued = false; initialize(); });
}).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
document.addEventListener('shopify:section:load', initialize);
initialize();
